export default "__VITE_ASSET__B_SBUNNV__"